import React from "react";

// import functions and contants
import userRolesAndRights from "../../constants/userRolesAndRights";
import authorization from "../../auth/authorization";
import { useAuthenticatedSession } from "../../context/AuthProvider";

const UserRolesAndRightsHOComponent = (WrappedComponent) => {
  const HOC = (props) => {
    const { user } = useAuthenticatedSession();
    if (!user) return null;

    return <WrappedComponent
      {...props}
      userType={userRolesAndRights[user.type].userType}
      userRights={userRolesAndRights[user.type].rights}
    />
  };

  return HOC;
};

export default UserRolesAndRightsHOComponent;